export default __webpack_public_path__ + "static/redes2019-41a7ac8e224dcf1e5a81666b0516a927.jpg";